import { render } from "./Footer.vue?vue&type=template&id=777b0e67&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=777b0e67&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-777b0e67"

export default script